export default __webpack_public_path__ + "static/media/sakura.5d4521df.JPG";